import { render, staticRenderFns } from "./ModalAdicionarIniciativa.vue?vue&type=template&id=44c09311&scoped=true"
import script from "./ModalAdicionarIniciativa.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarIniciativa.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarIniciativa.vue?vue&type=style&index=0&id=44c09311&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c09311",
  null
  
)

export default component.exports